import React from "react";

import HomeUI from "../../../../ui/homeUI/_index";

const ElectronicManagerReport = () => {
  return (
    <>
      <HomeUI />
    </>
  );
};

export default ElectronicManagerReport;
